/* Greenvill Crafts theme — vanilla JS, no dependencies */
(() => {
  'use strict';
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const debounce = (fn, ms = 300) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; };
  const theme = window.theme || { routes: {}, strings: {} };
  const parse = (html) => new DOMParser().parseFromString(html, 'text/html');

  /* ---------- Live region + toast (popover="manual" in the top layer) ---------- */
  function announce(msg) {
    const lr = $('[data-live-region]'); if (!lr) return;
    lr.textContent = ''; setTimeout(() => { lr.textContent = msg; }, 100);
  }
  function toast(msg) {
    const el = $('.toast'); if (!el) return;
    const text = $('.toast__msg', el) || el; text.textContent = msg;
    const native = typeof el.showPopover === 'function';
    if (native) { if (!el.matches(':popover-open')) el.showPopover(); } else el.classList.add('is-shown');
    announce(msg);
    clearTimeout(el._t);
    el._t = setTimeout(() => {
      if (native) { if (el.matches(':popover-open')) el.hidePopover(); } else el.classList.remove('is-shown');
    }, 4000);
  }
  if (!('popover' in HTMLElement.prototype)) {
    document.addEventListener('click', (e) => { if (e.target.closest('.toast__close')) $('.toast').classList.remove('is-shown'); });
  }

  /* ---------- Drawers ----------
     Menu & cart: native <dialog> opened with showModal() — the browser makes the page inert, traps focus,
     handles Esc and (with closedby="any") light-dismiss, and restores focus on close.
     Mobile filters: custom overlay; the rest of the page is made inert while it is open. */
  const setExpanded = (id, v) => $$('[aria-controls="' + id + '"]').forEach(b => b.setAttribute('aria-expanded', String(v)));
  const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let lastFocus = null;
  function setOutsideInert(el, on) {
    for (let n = el; n && n !== document.body; n = n.parentElement) {
      const parent = n.parentElement; if (!parent) break;
      for (const sib of parent.children) {
        if (sib === n || /^(SCRIPT|STYLE|LINK|TEMPLATE)$/.test(sib.tagName)) continue;
        if (on) { if (!sib.inert) { sib.inert = true; sib.dataset.drawerInert = ''; } }
        else if ('drawerInert' in sib.dataset) { sib.inert = false; delete sib.dataset.drawerInert; }
      }
    }
  }
  function openDrawer(id) {
    const d = document.getElementById(id); if (!d) return;
    if (d instanceof HTMLDialogElement) {
      if (!d.open) d.showModal();
    } else {
      lastFocus = document.activeElement;
      const panel = $('.drawer__panel', d);
      if (panel) { panel.setAttribute('role', 'dialog'); panel.setAttribute('aria-modal', 'true'); if (panel.dataset.dialogLabel) panel.setAttribute('aria-labelledby', panel.dataset.dialogLabel); }
      d.classList.add('is-open'); document.body.classList.add('drawer-open');
      setOutsideInert(d, true);
      const f = $('.drawer__close', d) || $('a,button,input', d); f && f.focus();
    }
    setExpanded(id, true);
  }
  function closeDrawer(d) {
    if (!d) return;
    if (d instanceof HTMLDialogElement) { if (d.open) d.close(); setExpanded(d.id, false); return; }
    d.classList.remove('is-open'); document.body.classList.remove('drawer-open');
    const panel = $('.drawer__panel', d);
    if (panel) ['role', 'aria-modal', 'aria-labelledby'].forEach(a => panel.removeAttribute(a));
    setOutsideInert(d, false);
    setExpanded(d.id, false);
    lastFocus && lastFocus.focus && lastFocus.focus();
  }
  const supportsClosedBy = 'closedBy' in HTMLDialogElement.prototype;
  $$('dialog.modal-drawer').forEach(dlg => {
    dlg.addEventListener('close', () => setExpanded(dlg.id, false));
    if (!supportsClosedBy) {
      // Light-dismiss fallback (e.g. Safari): a click on the ::backdrop targets the dialog itself, outside its box.
      dlg.addEventListener('click', (e) => {
        if (e.target !== dlg) return;
        const r = dlg.getBoundingClientRect();
        const inside = r.top <= e.clientY && e.clientY <= r.bottom && r.left <= e.clientX && e.clientX <= r.right;
        if (!inside) dlg.close();
      });
    }
  });
  // If the viewport grows to desktop while the mobile filter overlay is open, release it.
  window.matchMedia('(min-width: 990px)').addEventListener('change', (mq) => { if (mq.matches) $$('.drawer.is-open').forEach(closeDrawer); });
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      if (opener.dataset.drawerOpen === 'CartDrawer' && theme.cartType !== 'drawer') return;
      e.preventDefault(); openDrawer(opener.dataset.drawerOpen); return;
    }
    const closer = e.target.closest('[data-drawer-close]');
    if (closer) closeDrawer(closer.closest('dialog, .drawer'));
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      const d = $('.drawer.is-open'); if (d) closeDrawer(d);
      $$('.menu details[open]').forEach(x => x.removeAttribute('open'));
    }
  });

  /* ---------- Mega menu: one open at a time, close on outside click ---------- */
  $$('.menu > li > details').forEach(det => {
    det.addEventListener('toggle', () => { if (det.open) $$('.menu > li > details[open]').forEach(o => o !== det && o.removeAttribute('open')); });
  });
  document.addEventListener('click', (e) => { if (!e.target.closest('.menu')) $$('.menu > li > details[open]').forEach(o => o.removeAttribute('open')); });

  /* ---------- Announcement rotator ---------- */
  $$('[data-announcement]').forEach(root => {
    const msgs = $$('.announcement__message', root); if (msgs.length < 2) return;
    let i = 0; const speed = (parseInt(root.dataset.speed, 10) || 5) * 1000;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    setInterval(() => { msgs[i].classList.remove('is-active'); i = (i + 1) % msgs.length; msgs[i].classList.add('is-active'); }, speed);
  });

  /* ---------- Cart ---------- */
  const cartSections = () => {
    const ids = ['cart-drawer'];
    const main = $('[data-cart-section]'); if (main) ids.push(main.dataset.cartSection);
    return ids;
  };
  function renderCartSections(sections) {
    if (!sections) return;
    if (sections['cart-drawer']) {
      const drawer = $('#CartDrawer');
      const fresh = parse(sections['cart-drawer']).querySelector('#CartDrawer');
      if (drawer && fresh) { $('.drawer__panel', drawer).innerHTML = $('.drawer__panel', fresh).innerHTML; }
    }
    const main = $('[data-cart-section]');
    if (main && sections[main.dataset.cartSection]) {
      const fresh = parse(sections[main.dataset.cartSection]).querySelector('[data-cart-section]');
      if (fresh) main.innerHTML = fresh.innerHTML;
    }
  }
  async function updateCount() {
    try {
      const cart = await fetch(theme.routes.cart + '.js').then(r => r.json());
      $$('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; el.dataset.count = cart.item_count; });
      return cart;
    } catch (e) { return null; }
  }

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-product-form]'); if (!form) return;
    e.preventDefault();
    const btn = $('[type=submit]', form); btn && btn.classList.add('is-loading');
    const fd = new FormData(form);
    if (theme.cartType === 'drawer') { fd.append('sections', cartSections().join(',')); fd.append('sections_url', window.location.pathname); }
    try {
      const res = await fetch(theme.routes.cartAdd + '.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body: fd });
      const data = await res.json();
      if (!res.ok || data.status) { toast(data.description || data.message || theme.strings.error); return; }
      if (theme.cartType !== 'drawer') { window.location.href = theme.routes.cart; return; }
      renderCartSections(data.sections);
      await updateCount();
      openDrawer('CartDrawer');
    } catch (err) { toast(theme.strings.error); }
    finally { btn && btn.classList.remove('is-loading'); }
  });

  async function changeLine(line, quantity) {
    const wrap = $('#CartDrawer .drawer__panel'); wrap && wrap.classList.add('is-loading');
    try {
      const res = await fetch(theme.routes.cartChange + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity, sections: cartSections(), sections_url: window.location.pathname })
      });
      const data = await res.json();
      if (data.status) toast(data.description || data.message);
      renderCartSections(data.sections);
      await updateCount();
    } catch (err) { toast(theme.strings.error); }
    finally { wrap && wrap.classList.remove('is-loading'); }
  }
  document.addEventListener('click', (e) => {
    const rm = e.target.closest('[data-cart-remove]');
    if (rm) { e.preventDefault(); changeLine(parseInt(rm.dataset.cartRemove, 10), 0); }
  });
  document.addEventListener('change', debounce((e) => {
    const input = e.target.closest && e.target.closest('[data-cart-line]');
    if (input) changeLine(parseInt(input.dataset.cartLine, 10), Math.max(0, parseInt(input.value, 10) || 0));
  }, 350));
  document.addEventListener('change', (e) => {
    const note = e.target.closest && e.target.closest('[data-cart-note]');
    if (note) fetch(theme.routes.cartUpdate + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) });
  });

  /* External cart refresh (used by WebMCP tools) */
  document.addEventListener('theme:cart:refresh', async (e) => {
    try {
      const data = await fetch(`${theme.routes.root.replace(/\/$/, '')}/?sections=${cartSections().join(',')}`).then(r => r.json());
      renderCartSections(data);
      await updateCount();
      if (e.detail && e.detail.open && theme.cartType === 'drawer') openDrawer('CartDrawer');
    } catch (err) { /* ignore */ }
    document.dispatchEvent(new CustomEvent('theme:cart:refreshed'));
  });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qty]'); if (!b) return;
    e.preventDefault();
    const input = $('input', b.closest('.qty')); if (!input) return;
    const min = parseInt(input.min || '0', 10); const step = parseInt(input.step || '1', 10);
    const v = (parseInt(input.value, 10) || 0) + (b.dataset.qty === 'plus' ? step : -step);
    input.value = Math.max(min, v);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Variant picker (server-rendered updates via Section Rendering API) ---------- */
  $$('[data-variant-picker]').forEach(picker => {
    const section = picker.closest('[data-section-id]'); if (!section) return;
    const sectionId = section.dataset.sectionId;
    const variants = JSON.parse($('[data-variants-json]', section).textContent);
    const form = $('form[data-product-form]', section);
    const idInput = form && $('input[name=id]', form);
    const selected = () => $$('fieldset', picker).map(fs => { const c = $('input:checked', fs); return c ? c.value : null; });

    function markAvailability(opts) {
      $$('fieldset', picker).forEach((fs, idx) => {
        $$('input', fs).forEach(inp => {
          const test = opts.slice(); test[idx] = inp.value;
          const ok = variants.some(v => v.available && v.options.every((o, i) => o === test[i]));
          inp.classList.toggle('is-unavailable', !ok);
        });
      });
    }
    markAvailability(selected());

    picker.addEventListener('change', async () => {
      const opts = selected();
      const v = variants.find(x => x.options.every((o, i) => o === opts[i]));
      markAvailability(opts);
      $$('fieldset', picker).forEach((fs, i) => { const s = $('legend span', fs); if (s) s.textContent = opts[i]; });
      const atc = $$('[data-add-to-cart]', section);
      if (!v) { atc.forEach(b => { b.disabled = true; $('span', b).textContent = theme.strings.unavailable; }); return; }
      if (idInput) idInput.value = v.id;
      const url = new URL(window.location.href); url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
      if (v.featured_media) scrollGalleryTo(section, v.featured_media.id);
      let label = null;
      try {
        const html = await fetch(`${section.dataset.url}?variant=${v.id}&section_id=${sectionId}`).then(r => r.text());
        const doc = parse(html);
        // Button label (Add to cart / Pre-order / Back order) comes from the server-rendered section.
        const freshBtn = doc.querySelector('[data-main-atc] [data-add-to-cart] span');
        if (freshBtn) label = freshBtn.textContent.trim();
        $$('[data-dynamic]', section).forEach(el => {
          const fresh = doc.querySelector(`[data-dynamic="${el.dataset.dynamic}"]`);
          if (fresh) el.innerHTML = fresh.innerHTML;
        });
      } catch (e) { /* keep current UI */ }
      atc.forEach(b => { b.disabled = !v.available; $('span', b).textContent = v.available ? (label || theme.strings.addToCart) : theme.strings.soldOut; });
    });
  });

  /* ---------- Product gallery ---------- */
  function scrollGalleryTo(section, mediaId) {
    const slide = $(`[data-media-id="${mediaId}"]`, section); if (!slide) return;
    const track = slide.parentElement; track.scrollTo({ left: slide.offsetLeft, behavior: reduceMotion() ? 'auto' : 'smooth' });
  }
  $$('[data-gallery]').forEach(g => {
    const track = $('.gallery__main', g); const thumbs = $$('.gallery__thumb', g);
    const setCurrent = () => {
      const i = Math.round(track.scrollLeft / track.clientWidth);
      thumbs.forEach((t, idx) => t.setAttribute('aria-current', idx === i ? 'true' : 'false'));
    };
    track.addEventListener('scroll', debounce(setCurrent, 80));
    thumbs.forEach((t, idx) => t.addEventListener('click', () => track.scrollTo({ left: idx * track.clientWidth, behavior: reduceMotion() ? 'auto' : 'smooth' })));
    $$('.gallery__nav', g).forEach(b => b.addEventListener('click', () => {
      track.scrollBy({ left: (b.classList.contains('gallery__nav--next') ? 1 : -1) * track.clientWidth, behavior: reduceMotion() ? 'auto' : 'smooth' });
    }));
  });

  /* ---------- Sticky add to cart ---------- */
  const sticky = $('.sticky-atc'); const mainAtc = $('[data-main-atc]');
  if (sticky && mainAtc && 'IntersectionObserver' in window) {
    new IntersectionObserver(([en]) => {
      sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0);
    }).observe(mainAtc);
  }

  /* ---------- Predictive search ---------- */
  $$('[data-predictive-search]').forEach(form => {
    const input = $('input[name=q]', form); const results = $('.predictive', form);
    if (!input || !results) return;
    let active = -1;
    const close = () => { results.hidden = true; input.setAttribute('aria-expanded', 'false'); active = -1; };
    const run = debounce(async () => {
      const q = input.value.trim();
      if (q.length < 2) { close(); return; }
      try {
        const url = `${theme.routes.predictiveSearch}?q=${encodeURIComponent(q)}&section_id=predictive-search&resources[type]=product,collection,article,page&resources[limit]=4&resources[options][unavailable_products]=last`;
        const html = await fetch(url).then(r => r.text());
        const fresh = parse(html).querySelector('#predictive-search-results');
        results.innerHTML = fresh ? fresh.innerHTML : '';
        results.hidden = false; input.setAttribute('aria-expanded', 'true');
      } catch (e) { close(); }
    }, 250);
    input.addEventListener('input', run);
    input.addEventListener('keydown', (e) => {
      const items = $$('[role=option]', results); if (results.hidden || !items.length) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        active = (active + (e.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length;
        items.forEach((it, i) => it.setAttribute('aria-selected', i === active ? 'true' : 'false'));
        input.setAttribute('aria-activedescendant', items[active].id);
      } else if (e.key === 'Enter' && active > -1) { e.preventDefault(); items[active].click(); }
    });
    document.addEventListener('click', (e) => { if (!form.contains(e.target)) close(); });
  });

  /* ---------- Collection filtering & sorting (Section Rendering API) ---------- */
  const facetSubmit = debounce((form) => applyFacets(new URLSearchParams(new FormData(form)).toString(), form.dataset.sectionId), 450);
  document.addEventListener('change', (e) => {
    const f = e.target.form; if (f && f.matches('[data-facets-form]')) facetSubmit(f);
  });
  document.addEventListener('submit', (e) => {
    const f = e.target.closest('[data-facets-form]'); if (!f) return; e.preventDefault(); facetSubmit(f);
  });
  async function applyFacets(query, sectionId, push = true) {
    const grid = $('[data-product-grid]'); grid && grid.classList.add('is-loading');
    const params = new URLSearchParams(query);
    [...params.keys()].forEach(k => { if (params.get(k) === '') params.delete(k); });
    const qs = params.toString();
    try {
      const html = await fetch(`${window.location.pathname}?section_id=${sectionId}${qs ? '&' + qs : ''}`).then(r => r.text());
      const doc = parse(html);
      ['[data-facets-root]', '[data-product-grid-wrap]', '[data-toolbar]', '[data-active-filters]'].forEach(sel => {
        const fresh = doc.querySelector(sel); $$(sel).forEach(el => { if (fresh) el.innerHTML = fresh.innerHTML; });
      });
      if (push) {
        window.history.pushState({ facets: qs, sectionId }, '', `${window.location.pathname}${qs ? '?' + qs : ''}`);
        // Back to the top of the page so shoppers see the start of the filtered results.
        window.scrollTo({ top: 0, behavior: reduceMotion() ? 'auto' : 'smooth' });
      }
    } catch (e) { window.location.search = qs; }
    finally { const g = $('[data-product-grid]'); g && g.classList.remove('is-loading'); }
  }
  document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-facet-link]'); if (!a) return;
    e.preventDefault();
    const u = new URL(a.href, window.location.origin);
    applyFacets(u.searchParams.toString(), a.dataset.sectionId);
  });
  window.addEventListener('popstate', (e) => { if (e.state && e.state.sectionId) applyFacets(e.state.facets, e.state.sectionId, false); });

  /* ---------- Product finder ---------- */
  document.addEventListener('submit', (e) => {
    const f = e.target.closest('form[data-finder]'); if (!f) return;
    const q = $('input[name=q]', f); if (q && q.value.trim()) return;
    const chosen = $$('[data-finder-select]', f).map(s => s.value).filter(Boolean);
    e.preventDefault();
    if (chosen.length) window.location.href = chosen[chosen.length - 1];
  });

  /* ---------- Product recommendations (lazy, Section Rendering API) ---------- */
  $$('[data-recommendations]').forEach(sec => {
    if ($('[data-recommendations-inner]', sec)) return;
    sec.classList.add('is-empty');
    const load = async () => {
      try {
        const html = await fetch(sec.dataset.url).then(r => r.text());
        const fresh = parse(html).querySelector('[data-recommendations]');
        if (fresh && fresh.querySelector('[data-recommendations-inner]')) { sec.innerHTML = fresh.innerHTML; sec.classList.remove('is-empty'); }
      } catch (e) { /* no recommendations */ }
    };
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(([en]) => { if (en.isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '0px 0px 400px 0px' });
      io.observe(sec);
    } else load();
  });

  /* ---------- Countdown ---------- */
  $$('[data-countdown]').forEach(el => {
    const end = new Date(el.dataset.countdown).getTime(); if (isNaN(end)) return;
    const set = (k, v) => { const n = $(`[data-unit="${k}"]`, el); if (n) n.textContent = String(v).padStart(2, '0'); };
    const tick = () => {
      const d = Math.max(0, end - Date.now());
      set('d', Math.floor(d / 864e5)); set('h', Math.floor(d / 36e5) % 24); set('m', Math.floor(d / 6e4) % 60); set('s', Math.floor(d / 1e3) % 60);
      if (d === 0) { clearInterval(t); const box = el.closest('[data-hide-on-expire]'); box && (box.hidden = true); }
    };
    const t = setInterval(tick, 1000); tick();
  });

  /* ---------- Expandable text ---------- */
  $$('[data-expandable]').forEach(box => {
    const btn = $('.expandable__toggle', box); const content = $('.expandable__content', box);
    if (!btn || !content) return;
    // ResizeObserver hands us sizes after layout, so reading them here doesn't force an extra reflow
    if ('ResizeObserver' in window) {
      new ResizeObserver(() => { if (box.dataset.collapsed !== 'false') btn.hidden = content.scrollHeight <= content.clientHeight + 10; }).observe(content);
    }
    btn.addEventListener('click', () => {
      const collapsed = box.dataset.collapsed === 'true';
      box.dataset.collapsed = collapsed ? 'false' : 'true';
      btn.setAttribute('aria-expanded', collapsed ? 'true' : 'false');
      $('span', btn).textContent = collapsed ? btn.dataset.less : btn.dataset.more;
    });
  });

  /* ---------- Lazy video ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-video-play]'); if (!b) return;
    const wrap = b.closest('.video-wrap'); const tpl = $('template', wrap);
    if (tpl) { wrap.innerHTML = ''; wrap.appendChild(tpl.content.cloneNode(true)); const v = $('video', wrap); v && v.play(); }
  });

  /* ---------- Reveal on scroll ---------- */
  // Scroll-driven CSS handles reveals where animation-timeline is supported; this is the fallback.
  const scrollDriven = window.CSS && CSS.supports('(animation-timeline: view()) and (animation-range: entry)');
  if (!scrollDriven && 'IntersectionObserver' in window && document.body.classList.contains('has-reveal')) {
    const io = new IntersectionObserver((entries) => entries.forEach(en => { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -60px 0px' });
    $$('.reveal').forEach(el => io.observe(el));
  } else { $$('.reveal').forEach(el => el.classList.add('is-visible')); }

  /* ---------- Back to top ---------- */
  const btt = $('.back-to-top');
  if (btt) {
    window.addEventListener('scroll', debounce(() => { btt.hidden = window.scrollY < 900; }, 100), { passive: true });
    btt.addEventListener('click', () => window.scrollTo({ top: 0, behavior: reduceMotion() ? 'auto' : 'smooth' }));
  }

  /* ---------- Localization selects auto-submit ---------- */
  document.addEventListener('change', (e) => { const s = e.target.closest && e.target.closest('[data-localization-select]'); if (s) s.form.submit(); });

  /* ---------- Share button ---------- */
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-share]'); if (!b) return;
    const data = { title: document.title, url: b.dataset.share };
    if (navigator.share) { try { await navigator.share(data); } catch (err) { /* cancelled */ } }
    else if (navigator.clipboard) { await navigator.clipboard.writeText(data.url); toast(b.dataset.copied || 'Link copied'); }
  });

  /* ---------- Address forms: preselect saved country ---------- */
  $$('select[data-default]').forEach(s => { if (s.dataset.default) s.value = s.dataset.default; });

  /* ---------- Theme editor support ---------- */
  document.addEventListener('shopify:section:load', (e) => {
    $$('.reveal', e.target).forEach(el => el.classList.add('is-visible'));
  });
})();
